import { useEffect } from 'react';

import { hooks } from 'helpers';
import { createFilterStatus } from 'helpers/misc';
import { AdminView } from 'components';
import { getAllAdmins } from 'store/actions';

import useAdmins from './useAdmins';

const Admins = () => {
  const dispatch = hooks.useAppDispatch();
  const {
    thTitles,
    openModalDelete,
    setOpenModalDelete,
    selectedItem,
    setSelectedItem,
    data,
    paginationFunction,
    pagination,
    onDeleteAdmin,
    onSearchAdmins,
    selectedStatus,
    setSelectedStatus,
    formStatus
  } = useAdmins();

  useEffect(() => {
    dispatch(getAllAdmins('', 1, ''));
  }, []);

  return (
    <AdminView
      cellType='edit_delete'
      createText='Create Admin'
      thTitles={ thTitles }
      editLink='admins/edit'
      viewLink='admins/view'
      items={ data }
      title='Admins'
      type='admins'
      createLink='admins/post'
      showModalDelete={ openModalDelete }
      setShowModalDelete={ setOpenModalDelete }
      selectedItem={ selectedItem }
      setSelectedItem={ setSelectedItem }
      onClickPagination={ paginationFunction }
      pagination={ pagination }
      onDeleteModalClick={ onDeleteAdmin }
      onChangeSearch={ onSearchAdmins }
      withFilter={ true }
      filter={ createFilterStatus(formStatus) }
      getData={ getAllAdmins }
      selectedStatus={ selectedStatus }
      setSelectedStatus={ setSelectedStatus }
    />
  );
};

export default Admins;